export const PASSWORD_CRITERIA = [
  {
    key: "length",
    label: "At least 8 characters",
    test: (value) => value.length >= 8,
  },
  {
    key: "uppercase",
    label: "One uppercase letter (A-Z)",
    test: (value) => /[A-Z]/.test(value),
  },
  {
    key: "lowercase",
    label: "One lowercase letter (a-z)",
    test: (value) => /[a-z]/.test(value),
  },
  {
    key: "number",
    label: "One number (0-9)",
    test: (value) => /\d/.test(value),
  },
  {
    key: "specialCharacter",
    label: "One special character (!@#$%^&*)",
    test: (value) => /[^A-Za-z0-9]/.test(value),
  },
];

export const getPasswordCriteriaState = (password = "") =>
  PASSWORD_CRITERIA.map((criteria) => ({
    ...criteria,
    isValid: criteria.test(password),
  }));
